import axios from "axios";

export const postEmailCORASupport = async (summary: string) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API}/Email/cora-support`,
      { summary: summary }
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
